import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { SignedEditionDndaWorkflowStateViewStore } from "../../store";
import { SignedEditionDndaWorkflowStateView } from "./SignedEditionDndaWorkflowStateView";
import { SignedEditionDndaWorkflowStateUpdateStore } from "../../store";
import { SignedEditionDndaWorkflowStateUpdate } from "../update/SignedEditionDndaWorkflowStateUpdate";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type SignedEditionDndaWorkflowStateDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const SignedEditionDndaWorkflowStateDrawerContent: React.FC<SignedEditionDndaWorkflowStateDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);
    const updateInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new SignedEditionDndaWorkflowStateViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    const updateStore = useMemo(() => {
      const s = new SignedEditionDndaWorkflowStateUpdateStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "update" &&
        entityId &&
        updateInitializedRef.current !== entityId
      ) {
        updateInitializedRef.current = entityId;
        updateStore.initialize({ id: entityId });
      }
    }, [entityId, mode, updateStore]);

    if (mode === "update") {
      if (
        updateStore.status === "processing" ||
        updateStore.status === "uninitialized"
      ) {
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <CircularProgress />
          </Box>
        );
      }
      return (
        <SignedEditionDndaWorkflowStateUpdate
          signedEditionDndaWorkflowStateUpdateStore={updateStore}
        />
      );
    }

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <SignedEditionDndaWorkflowStateView
        signedEditionDndaWorkflowStateViewStore={viewStore}
      />
    );
  });
